import { useEffect, useState } from "react"
import SimilarSkill from "./SimilarSkill"
import { useApiService } from "../hooks/Api/useApiService"
import { useParams } from "react-router-dom"

const ShareSkill = () => {
  const [skill, setSkill] = useState(null)
  const { id } = useParams()
  const { postData } = useApiService()

  useEffect(() => {
    const fetchSkill = async () => {
      const data = await postData("skills/getskillbyid", { id })
      setSkill(data?.skill)
    }
    fetchSkill()
  }, [id])

  return <SimilarSkill skill={skill} />
}
export default ShareSkill
